import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RaisedButton} from 'material-ui';
import { TextField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';


class SignForm extends Component {
  labels = {
    accountName: 'アカウント名',
    password: 'パスワード',
    signIn: 'サインイン',
    clear: 'クリア',
  };

  styles = {
    textStyle: {
      width: '400px',
    },
    formStyle: {
      paddingLeft: '100px',
    },
    buttonStyle: {
      paddingLeft: '210px'
    },
  };

  handleSubmit = () => {
    this.props.authActions.signIn(
      this.props.signForm.username,
      this.props.signForm.password
    );
  }

  handleReset = () => {
    this.props.reset();
  }

  componentDidMount = () => {
    this.refs.username
      .getRenderedComponent()
      .getRenderedComponent()
      .focus();
  }

  componentWillMount = () => {
    if (this.props.auth.isAuthenticated === true) {
      window.location.href = '/institutions/list';
    }
  }

  componentDidUpdate = () => {
    if (this.props.auth.isAuthenticated === true) {
      window.location.href = '/institutions/list';
    }
  }

  render() {
    // TODO: 入力フォームを必須にして、未入力であればvalidation errorとなる対応を入れたい
    // const required = value => (value == null ? 'Required' : undefined);
    const wellStyles = {maxWidth: 600, margin: '0 auto 10px'};

    return (
      <form style={wellStyles} >
        <div style={this.styles.formStyle}>
          <Field
            name="username"
            component={TextField}
            hintText={this.labels.accountName}
            floatingLabelText={this.labels.accountName}
            validate={ [(value) => {},] }
            ref="username"
            style={this.styles.textStyle}
            withRef
          />
        </div>
        <div style={this.styles.formStyle}>
          <Field
            name="password"
            component={TextField}
            type="password"
            hintText={this.labels.password}
            floatingLabelText={this.labels.password}
            validate={ [(value) => {},] }
            ref="pasword"
            style={this.styles.textStyle}
            withRef
          />
        </div>
        <div style={this.styles.buttonStyle}>
          <RaisedButton label={this.labels.signIn} type="button" onClick={() => this.handleSubmit()} />
          <RaisedButton label={this.labels.clear} type="button" onClick={() => this.handleReset()}/>
        </div>
      </form>
    );
  }
}

SignForm.propTypes = {
  auth: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  signForm: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'signForm'
})(SignForm);



// WEBPACK FOOTER //
// ./src/components/SignForm.js